import { useEffect, useState } from "react";
import { Store } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Spinner } from "@/components/common";
import { Switch } from "@/components/ui/switch";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function ClinicHours() {
  const [h, setH] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/clinic-hours").then((r) => setH(r.data.hours)); }, []);
  const set = (i, v) => setH(h.map((x, j) => (j === i ? v : x)));
  const save = async () => {
    setBusy(true);
    try { await api.put("/settings/clinic-hours", { hours: h }); toast.success("Clinic hours saved · landing pages and closed-hours tags updated"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!h) return <Spinner />;
  return (
    <Panel title="Clinic hours (SGT)" icon={Store} testid="clinic-hours-panel">
      <p className="mb-4 text-sm text-slate-400">One source for the landing pages' "Open now" text, the "Arrived while closed" lead tag, the morning email and the extra-hours report.</p>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {DAYS.map((d, i) => (
          <div key={d} className="flex items-center gap-2 rounded-md bg-[#0a101d] p-2 text-xs text-slate-300" data-testid={`clinic-hours-${d.toLowerCase()}`}>
            <span className="w-8 font-semibold">{d}</span>
            <Switch data-testid={`clinic-open-${d.toLowerCase()}`} checked={!!h[i]} onCheckedChange={(v) => set(i, v ? [9, 18] : null)} />
            {h[i] ? <>
              <input data-testid={`clinic-from-${d.toLowerCase()}`} type="number" min="0" max="23" className="cc-input w-14 px-1 py-0.5" value={h[i][0]} onChange={(e) => set(i, [Number(e.target.value), h[i][1]])} />–
              <input data-testid={`clinic-to-${d.toLowerCase()}`} type="number" min="1" max="24" className="cc-input w-14 px-1 py-0.5" value={h[i][1]} onChange={(e) => set(i, [h[i][0], Number(e.target.value)])} />
            </> : <span className="text-slate-500">Closed</span>}
          </div>
        ))}
      </div>
      <button data-testid="clinic-hours-save" onClick={save} disabled={busy} className="cc-btn cc-btn-primary mt-4 px-3 py-1.5 text-xs">{busy ? <Spinner className="h-3.5 w-3.5" /> : null} Save clinic hours</button>
    </Panel>
  );
}
